import TagManager from "react-gtm-module";
import {
  OfferSummaryDataLayer,
  Events,
  FunnelViewDataLayer,
  InitDataLayer,
  StepNumbers,
  KycDataLayer,
  PurchaseDataLayer,
  ErrorMonitor,
} from "./analytics.ts";
import { AxiosError } from "axios";

export const initTagManager = (gtmId: string) => {
  TagManager.initialize({ gtmId });
};

export const pushLayer = (dataLayer: any) => {
  TagManager.dataLayer({
    dataLayer,
  });
};

export const sendInitEvent = (contactId?: string) => {
  const initDataLayer: InitDataLayer = {
    event: Events.INIT,
    user_id: contactId ?? "",
    is_logged: !!contactId,
  };

  pushLayer(initDataLayer);
};

export const sendFunnelViewEvent = (window: Window & typeof globalThis) => {
  const pageSection = window.location.pathname.split("/").at(1) || "landing";
  const pageName =
    window.location.pathname.split("/").splice(2).join("_").replace("-", "_") ||
    "landing";

  const funnelViewDataLayer: FunnelViewDataLayer = {
    event: Events.E02_FUNNEL_VIEW,
    page_path: window.location.pathname,
    page_section: pageSection,
    page_name: pageName,
    page_url: window.location.href,
    page_host: window.location.host,
    previous_page_path: "",
    previous_page_section: "",
    step_number: StepNumbers[window.location.pathname],
    step_name: `${pageSection}:${pageName}`,
  };

  pushLayer(funnelViewDataLayer);
};

export const sendOfferSummaryEvent = (
  window: Window & typeof globalThis,
  amount: number,
  term: number,
  purpose: string,
) => {
  const pageSection = window.location.pathname.split("/").at(1) || "landing";
  const pageName =
    window.location.pathname.split("/").splice(2).join("_").replace("-", "_") ||
    "landing";

  const offerSummaryDataLayer: OfferSummaryDataLayer = {
    event: Events.E14_OFFER_SUMMARY,
    page_path: window.location.pathname,
    page_section: pageSection,
    page_name: pageName,
    page_url: window.location.href,
    page_host: window.location.host,
    previous_page_path: "",
    previous_page_section: "",
    step_number: StepNumbers[window.location.pathname],
    step_name: `${pageSection}:${pageName}`,
    durata_mesi: term,
    importo: amount,
    progetto: purpose,
  };

  pushLayer(offerSummaryDataLayer);
};

export const sendKycEvent = (
  window: Window & typeof globalThis,
  amount: number,
  term: number,
  purpose: string,
) => {
  const pageSection = window.location.pathname.split("/").at(1) || "landing";
  const pageName =
    window.location.pathname.split("/").splice(2).join("_").replace("-", "_") ||
    "landing";
  const kycDataLayer: KycDataLayer = {
    event: Events.E15_KYC,
    page_path: window.location.pathname,
    page_section: pageSection,
    page_name: pageName,
    page_url: window.location.href,
    page_host: window.location.host,
    previous_page_path: "",
    previous_page_section: "",
    step_number: StepNumbers[window.location.pathname],
    step_name: `${pageSection}:${pageName}`,
    durata_mesi: term,
    importo: amount,
    progetto: purpose,
  };

  pushLayer(kycDataLayer);
};

export const sendPurchaseEvent = (
  window: Window & typeof globalThis,
  amount: number,
  term: number,
  purpose: string,
  positionId: string,
  installmentAmount: number,
  tan: number,
  taeg: number,
) => {
  const pageSection = window.location.pathname.split("/").at(1) || "landing";
  const pageName =
    window.location.pathname.split("/").splice(2).join("_").replace("-", "_") ||
    "landing";

  const kycDataLayer: PurchaseDataLayer = {
    event: Events.E16_PURCHASE,
    page_path: window.location.pathname,
    page_section: pageSection,
    page_name: pageName,
    page_url: window.location.href,
    page_host: window.location.host,
    previous_page_path: "",
    previous_page_section: "",
    step_number: StepNumbers[window.location.pathname],
    step_name: `${pageSection}:${pageName}`,
    durata_mesi: term,
    importo: amount,
    progetto: purpose,
    rata_mensile: 0,
    taeg,
    tan,
    currency: "EUR",
    value: installmentAmount,
    transactionId: positionId,
    paymentType: "",
  };

  pushLayer(kycDataLayer);
};

export const pushErrorMonitor = (error: AxiosError) => {
  const dataLaterErrorMonitor: ErrorMonitor = {
    event: Events.ERROR_MONITOR,
    error_type: `${error.message || ""} ${error.code}`,
    error_code: error.code || "",
    error_line: "",
    error_url: window.location.href || "",
    error_module: "",
  };

  pushLayer(dataLaterErrorMonitor);
};
